import { handleRequest } from '../../services'

const state = {
  employees: [],
  selectedEmployees: {},
  employeesSheetVerify: [],
  companiesSheetVerify: [],
  companiesSheetVerifySelected: {
    models: {},
    items: []
  },
  employeesSheetVerifySelected: {
    models: {},
    items: []
  },
  isEmployeesSheetVerifyLoading: false,
  datesVerify: [],
  datesVerifySelected: {
    models: {},
    items: []
  },
  isDatesVerifyLoading: false,
  search: {},
  groupsSheetVerify: [],
  groupsSheetVerifySelected: {models: {}, items: []}
}

const getters = {
  employees: state => {
    return state.employees
  },
  selectedEmployees: state => {
    return state.selectedEmployees
  },
  employeesSheetVerify: state => {
    return state.employeesSheetVerify
  },
  groupsSheetVerify: state => state.groupsSheetVerify,
  companiesSheetVerify: state => { return state.companiesSheetVerify },
  employeesSheetVerifySelected: state => {
    return state.employeesSheetVerifySelected
  },
  companiesSheetVerifySelected: state => {
    return state.employeesSheetVerifySelected
  },
  groupsSheetVerifySelected: state => {
    return state.groupsSheetVerifySelected
  },
  datesVerifySelected: state => {
    return state.datesVerifySelected
  },
  datesVerify: state => {
    return state.datesVerify
  },
  isEmployeesSheetVerifyLoading: state => {
    return state.isEmployeesSheetVerifyLoading
  },
  isDatesVerifyLoading: state => {
    return state.isDatesVerifyLoading
  },
  search: state => {
    return state.search
  }
}

const mutations = {
  resetSelectedEmployeesAndCompanies (state) {
    state.employeesSheetVerify = []
    state.companiesSheetVerify = []
    state.companiesSheetVerifySelected = {
      models: {},
      items: []
    }
    state.employeesSheetVerifySelected = {
      models: {},
      items: []
    }
  },
  setEmployees: (state, payload) => {
    state.employees = payload
  },
  selectEmployee: (state, payload) => {
    state.selectedEmployees[payload] = !state.selectedEmployees[payload]
    if (!state.selectedEmployees[payload]) {
      delete state.selectedEmployees[payload]
    }
  },
  select: (state, payload) => {
    let items = [
      ...state[payload.model + 'Selected'].items,
      payload.id
    ]

    if (state[payload.model + 'Selected'].items.includes(payload.id)) {
      items = items.filter(i => i !== payload.id)
    }

    state[payload.model + 'Selected'] = {
      models: {
        ...state[payload.model + 'Selected'].models,
        [payload.id]: state[payload.model + 'Selected'].models[payload.id]
      },
      items
    }
  },
  selectOne: (state, payload) => {
    state[payload.model + 'Selected'] = {
      models: {
        [payload.id]: state[payload.model + 'Selected'].models[payload.id]
      },
      items: [payload.id]
    }
  },
  employeesSheetVerify: (state, payload) => {
    state.employeesSheetVerify = payload
  },
  companiesSheetVerify: (state, payload) => {
    state.companiesSheetVerify = payload
  },
  groupsSheetVerify: (state, payload) => {
    state.groupsSheetVerify = payload
  },
  isEmployeesSheetVerifyLoading: (state, payload) => {
    state.isEmployeesSheetVerifyLoading = payload
  },
  datesVerify: (state, payload) => {
    let final = []
    payload.forEach(item => {
      final.push({id: item, date: item})
    })
    state.datesVerify = final
  },
  isDatesVerifyLoading: (state, payload) => {
    state.isDatesVerifyLoading = payload
  },
  search: (state, payload) => {
    state.search = {
      ...state.search,
      ...payload
    }
  }
}

const actions = {
  loadEmployees: async ({ commit }) => {
    let params = {
      active: true,
      fields: ['id', 'name'],
      order_by: 'name'
    }
    const response = await handleRequest.get('employee', null, params)
    const data = response.data.success
    commit('setEmployees', data)
  },
  select: ({ commit }, payload) => {
    commit('select', payload)
  },
  selectOne: ({ commit }, payload) => {
    commit('selectOne', payload)
  },
  loadEmployeesSheetVerify: async ({ commit }) => {
    commit('isEmployeesSheetVerifyLoading', true)

    const params = {by_month: state.datesVerifySelected.items[0]}
    const response = await handleRequest.api('sheet', null, params)
    commit('employeesSheetVerify', response.data)
    commit('isEmployeesSheetVerifyLoading', false)
  },
  loadCompaniesSheetVerify: async ({ commit }) => {
    commit('isEmployeesSheetVerifyLoading', true)

    const params = {by_month_company: state.datesVerifySelected.items[0]}
    const response = await handleRequest.api('sheet', null, params)
    commit('companiesSheetVerify', response.data)
    commit('isEmployeesSheetVerifyLoading', false)
  },
  loadGroupsSheetVerify: async ({ commit }) => {
    commit('isEmployeesSheetVerifyLoading', true)

    const params = {by_month_groups: state.datesVerifySelected.items[0]}
    const response = await handleRequest.api('sheet', null, params)
    commit('groupsSheetVerify', response.data.success)
    commit('isEmployeesSheetVerifyLoading', false)
  },
  loadDatesVerify: async ({ commit }) => {
    commit('isDatesVerifyLoading', true)
    const params = {
      open_months: true
    }
    const response = await handleRequest.api('sheet', null, params)
    commit('datesVerify', response.data)
    commit('isDatesVerifyLoading', false)
  },
  search: ({ commit }, payload) => {
    commit('search', payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/CheckList.js